import React from "react"
import PageHeader from "../../components/DashboardComponents/PageHeader"

/**
 * Lightweight placeholder for admin nav items that are not built yet.
 */
const AdminPlaceholder = ({ title = "Admin" }) => {
  document.title = `${title} | AMOK . EARTH Admin`

  return (
    <div className="admin-page">
      <PageHeader
        title={title}
        subtitle="This section is coming soon."
        className="admin-page__header"
      />
    </div>
  )
}

export default AdminPlaceholder
